module.exports = __webpack_public_path__ + "img/ico-gear.d7b4bf5a.svg";